import { useEffect, useState } from "react"
import type { SuccessFetch } from "types"
import { useApi } from "utils"
import { PaymentDetailBillServiceResponse } from "../types"

export const useDetailPaymentBillService = (payment_bill_id: string) => {
  const api = useApi();
  const [data, setData] = useState<PaymentDetailBillServiceResponse | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchUrl = () => api.get(`/paymentbill/get_payment_bill_service_by_payment_id?payment_bill_id=${payment_bill_id}`)

  const fetchData = () => {
    setLoading(true);

    fetchUrl()
    .then((res: SuccessFetch<{ payload: PaymentDetailBillServiceResponse }>) => setData(res.data.payload))
    .catch(() => setData(null))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(null);
      setLoading(true);
    }

    // eslint-disable-next-line
  }, [payment_bill_id]);

  return { data, isLoading, refetch }
}